import ReactGA from 'react-ga4';

import { constants } from '../constants';

ReactGA.initialize(constants.googleAnalyticsId);

export function pageView(path: string, title?: string) {
  ReactGA.send({ hitType: 'pageview', page: path, title });
}
